import { useState } from 'react';
import {
  KhoHang,
  MaterialUnitInfo,
  MaterialUnitKhoData,
  MaterialUnitVatTuData,
  MaterialUnitViTriData,
  VatTu,
  ViTri
} from '@/types/schemas';

export const useSearchFieldStates = (initialData?: MaterialUnitInfo | null) => {
  const [material, setmaterial] = useState<VatTu | MaterialUnitVatTuData | null>(initialData?.ma_vat_tu_data || null);
  const [warehouse, setwarehouse] = useState<KhoHang | MaterialUnitKhoData | null>(initialData?.ma_kho_data || null);
  const [location, setLocation] = useState<ViTri | MaterialUnitViTriData | null>(initialData?.ma_vi_tri_data || null);

  return {
    material,
    setmaterial,
    warehouse,
    setwarehouse,
    location,
    setLocation
  };
};

export type MaterialUnitSearchFields = ReturnType<typeof useSearchFieldStates>;
